import { C } from "../theme";
import { feedMeta } from "./meta";
import type { FeedEntry } from "../types";

export function FeedRow({ e }: { e: FeedEntry }) {
  const m = feedMeta(e.kind);
  return (
    <div
      style={{
        display: "flex",
        gap: 13,
        padding: "12px 0",
        borderBottom: `1px solid ${C.lineSoft}`,
      }}
    >
      <span
        style={{
          flexShrink: 0,
          marginTop: 5,
          width: 9,
          height: 9,
          borderRadius: 9,
          background: m.c,
        }}
      />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 12.5, color: C.ink }}>
          {e.zone && <span style={{ fontWeight: 600 }}>{e.zone} · </span>}
          <span style={{ color: C.textMid }}>{e.text}</span>
        </div>
        <div className="mono" style={{ marginTop: 3, fontSize: 11, color: C.muted }}>
          {e.time}
        </div>
      </div>
    </div>
  );
}
